<template>
  <div>
    <div>description: {{entraidmapper.description}} </div>
    <div>role: {{getBroleString}} </div>
    <div>mapping name: {{entraidmapper.mapping_name}} </div>
    <div>Created: {{entraidmapper.created}}</div>
    <div>Edited: {{entraidmapper.updated}}</div>
    <div class="company-mail-endings-details-buttons mt-2">
      <v-btn
        color="red"
        :disabled="is_edit"
        v-click-outside="deleteshurefalse"
        @click="delete_shure?
        deleteUObject({
            url: [
              {businesses: business.id},
              {entraidmappers: entraidmapper.id}
            ],
            url_prefix: ``
        }).then(() => {
          delete_shure = false;
          $router.push({name: 'CompanyEntraIdMappers'});
        })
        :
        delete_shure = true;
        "
      >
        {{delete_shure?'shure?':'delete'}}
      </v-btn>
    </div>
  </div>
</template>
<script>
  import { mapActions,mapGetters  } from 'vuex';
  export default {
    props: [],
    data: () => ({
      is_edit: false,
      delete_shure: false,
    }),
    computed: {
      ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects'
    ]),
      ...mapGetters('Business', [
      'getBusiness',
      'getBusinessRoles',
    ]),
      entraidmapper() {
        if (this.$store.state.Ultra.entraidmappers[this.$route.params.entra_id_mappers_id] !== undefined){
          return this.$store.state.Ultra.entraidmappers[this.$route.params.entra_id_mappers_id];
        }else{
          return {description: 'loading', brole_id: 'loading', mapping_name: 'loading', created: 'loading', updated: 'loading', id: -1};
        }
      },
      business() {
        let current_user = this.$store.getters['Auth/getUser'];
        return this.$store.state.Ultra.businesses[current_user.business.id];
      },
      getBroleString(){
        let roles = this.getUObjects({type: 'broles', ids: this.business.broles});
        if (roles.length == 0){
          return "invalid role id"
        }
        // from a list of roles, find the one with the same id as the entraidmapper
        let role = roles.find(role => role.id == this.entraidmapper.brole_id);
        if (role == undefined){
          return "invalid role id"
        }
        return role.name
      }
    },
    methods: {
      ...mapActions('Ultra', [
        'updateUObject',
        'deleteUObject'
      ]),
      deleteshurefalse() {
        this.delete_shure = false;
      }
    }
  }
</script>
<style>
  .company-mail-endings-details-ending-line {
    display: flex;
    align-items: center;
  }
  .company-mail-endings-details-buttons {
    display: flex;
  }
  .company-mail-endings-details-input {
    outline: 1px solid white;
    width: 300px;
  }
</style>
